import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=f63d5ab0&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"
import style0 from "./chat.vue?vue&type=style&index=0&id=f63d5ab0&prod&scoped=true&lang=css"
import style1 from "./chat.vue?vue&type=style&index=1&id=f63d5ab0&prod&lang=css"
import style2 from "./chat.vue?vue&type=style&index=2&id=f63d5ab0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63d5ab0",
  null
  
)

export default component.exports